import script from "./BackupLogCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BackupLogCard.vue?vue&type=script&setup=true&lang=js"

import "./BackupLogCard.vue?vue&type=style&index=0&id=f030d52c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f030d52c"]])

export default __exports__